/**
 * Real-time WebSocket package facade.
 *
 * The historical `@/services/simpleWebSocket` specifier re-exports from
 * here, so consumers and test mocks are agnostic to the file layout behind
 * the facade (client / auth / reconnect transport, generic subscription
 * registry, per-domain live APIs under ./domains).
 */

import { SimpleWebSocketService } from './service'

export { SimpleWebSocketService }

/** Shared singleton used by hooks, tokenEventHandler, and websocketCompat. */
export const webSocketService = new SimpleWebSocketService()
